module.exports = __webpack_public_path__ + "img/thumb_13.4db232e6.jpg";